import Vue from 'vue'
import WriteDialog from './WriteDialog.vue'
const WriteDialogCreater = Vue.extend(WriteDialog)
let writeDialogInstance

export default {
  open () {
    if (!writeDialogInstance) {
      writeDialogInstance = new WriteDialogCreater({
        el: document.createElement('div'),
      })
      document.body.appendChild(writeDialogInstance.$el)
    }
    writeDialogInstance.visible = true
  }
}
